import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { getField } from 'src/common/helper';
import Box from '@mui/material/Box';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

const textFont = {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '14.4px'
};

const outgoingIncoming = [
  '-',
  '入庫',
  '出庫'
];

type RecordItemProps = {
  items: any[];
  handleClickRow: () => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {
  
  return (
    <>
      {props.items.map((item: any, index: number) => (
        <TableRow
          hover
          key={index}
          sx={{
            '&:last-child td, &:last-child th': { border: 0 },
            '& .MuiTableCell-root.MuiTableCell-body': {
              py: '4px',
              borderBottom: '1px solid #F3F3F3',
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '14.4px'
            },
            height: '48px',
          }}
        >
          <TableCell component='td' scope='row'>
            <Typography
              sx={{
                ...textFont
              }}
              component={'label'}
            >
              {getField(item, 'thedate')}
            </Typography>
          </TableCell>

          <TableCell component='td' scope='row'>
            <Typography
              sx={{
                ...textFont
              }}
              component={'label'}
            >
              {getField(item, 'patient', '')}
            </Typography>
          </TableCell>

          <TableCell component='td' scope='row'>
            <Box
              sx={{
                width: '36px',
                height: '20px',
                borderRadius: '4px',
                bgcolor: getField(item, 'type', '0') === 1 ? '#A3AED0' : '#4FC1E9',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Typography
                sx={{
                  ...textFont,
                  color: '#FFFFFF !important',
                  alignContent: 'center'
                }}
                component={'label'}
              >
                {outgoingIncoming[getField(item, 'type', '0')]}
              </Typography>
            </Box>
          </TableCell>

          <TableCell component='td' scope='row' align='center'>
            <Typography
              sx={{
                ...textFont
              }}
              component={'label'}
            >
              {getField(item, 'qty')}
            </Typography>
          </TableCell>

          <TableCell component='td' scope='row' align='center'>
            <Typography
              sx={{
                ...textFont
              }}
              component={'label'}
            >
              {getField(item, 'cost', '0') !== '0' ? '¥' + getField(item, 'cost', '') : ''}
            </Typography>
          </TableCell>

          <TableCell component='td' scope='row' align='center'>
            <Typography
              sx={{
                ...textFont
              }}
              component={'label'}
            >
              {getField(item, 'price', '0') !== '0' ? '¥' + getField(item, 'price', '') : ''}
            </Typography>
          </TableCell>

          <TableCell component='td' scope='row'>
            {Number(getField(item, 'type', '0')) === 2 && (
              <BtnOutlineGradient text='入金詳細へ' handleButtonClick={props.handleClickRow} />
            )}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default RecordItem;
